module.exports = __webpack_public_path__ + "img/upload.9c6daca8.png";